import React from "react";

import Panel from "../../shared/bootstrap/Panel.jsx";
import RowWrapper from "../../shared/bootstrap/RowWrapper.jsx";

export default function GeneralInfoLeft({
  displayName,
  companyName,
  corpUrl,
  duns,
  uei,
  tin,
  cage,
  facets,
  ottpFacet,
  certifiedUrl,
  certifiedLogoUrl,
}) {
  return (
    <div className="col-sm-3">
      <Panel primary={false}>
        <RowWrapper>
          <div className="col-xs-12">
            <strong>{displayName}</strong>
          </div>
        </RowWrapper>
        <RowWrapper>
          <div className="col-xs-12">
            <strong>{companyName}</strong>
          </div>
        </RowWrapper>
        <RowWrapper>
          <div className="col-xs-12">
            <a target="_blank" href={`https://${corpUrl}`}>
              {corpUrl}
            </a>
          </div>
        </RowWrapper>
        <RowWrapper>
          <div className="col-xs-12">DUNS: {duns}</div>
        </RowWrapper>
        <RowWrapper>
          <div className="col-xs-12">UEI: {uei}</div>
        </RowWrapper>
        <RowWrapper>
          <div className="col-xs-12">TIN: {tin}</div>
        </RowWrapper>
        <RowWrapper>
          <div className="col-xs-12">CAGE: {cage}</div>
        </RowWrapper>
        {facets.find((facet) => facet.facetValue === "SECTION-889") && (
          <RowWrapper>
            <div className="col-xs-12">
              <a href="/section_889.shtml" target="_blank">
                Section 889 Certified
              </a>
            </div>
          </RowWrapper>
        )}
        {ottpFacet && (
          <RowWrapper>
            <div className="col-xs-12">
              <a href={certifiedUrl} target="_blank">
                <img className="logoCertified" alt="ottp Certified" src={certifiedLogoUrl} border="0" />
              </a>
            </div>
          </RowWrapper>
        )}
      </Panel>
    </div>
  );
}
